import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=61618df2&scoped=true"
import script from "./PlanDetails.vue?vue&type=script&lang=ts"
export * from "./PlanDetails.vue?vue&type=script&lang=ts"
import style0 from "./PlanDetails.vue?vue&type=style&index=0&id=61618df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61618df2",
  null
  
)

export default component.exports